import { render, staticRenderFns } from "./no-profile-alert.vue?vue&type=template&id=b30a0196&scoped=true&"
import script from "./no-profile-alert.vue?vue&type=script&lang=js&"
export * from "./no-profile-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30a0196",
  null
  
)

export default component.exports